// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__243GJ","range":"MonthRangeSwitch_range__2arDb","disabled":"MonthRangeSwitch_disabled__3Liv3"};